module.exports = __webpack_public_path__ + "img/TopState1Y.e2692990.png";